import React, { useState, useEffect } from 'react';
import ChatBot from './ChatBot';
import { X } from 'lucide-react';
import './ChatBot.css';

export default function ChatBotButton() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const open = () => setIsOpen(true);
    window.addEventListener('sovrynn-open-rynn', open);
    return () => window.removeEventListener('sovrynn-open-rynn', open);
  }, []);

  return (
    <>
      <button
        type="button"
        className="rynn-fab"
        onClick={() => setIsOpen(!isOpen)}
        title={isOpen ? 'Close Rynn' : 'Ask Rynn'}
        aria-label={isOpen ? 'Close Rynn' : 'Ask Rynn'}
        aria-expanded={isOpen}
      >
        {isOpen ? (
          <X className="rynn-fab__icon" size={26} strokeWidth={2} aria-hidden />
        ) : (
          <span className="rynn-fab__label">Rynn</span>
        )}
      </button>

      {isOpen && (
        <div className="rynn-panel" role="dialog" aria-label="Rynn compliance intelligence director">
          <header className="rynn-panel__header">
            <div className="rynn-panel__title">
              <p className="rynn-panel__name">Rynn</p>
              <p className="rynn-panel__subtitle">Your Compliance Intelligence Director</p>
            </div>
            <button
              type="button"
              className="rynn-panel__close"
              onClick={() => setIsOpen(false)}
              aria-label="Close chat"
            >
              <X size={20} />
            </button>
          </header>
          <div className="rynn-panel__body">
            <ChatBot onClose={() => setIsOpen(false)} modalMode />
          </div>
        </div>
      )}
    </>
  );
}
